import { useAppState } from '../../context/AppStateContext';
import { MoldOrder } from '../../types/mold';

const MoldOrderStatus = ({
  moldOrder,
  isShortVersion = false,
}: {
  moldOrder: MoldOrder;
  isShortVersion?: boolean;
}) => {
  const { getStatusColor, getStatusText } = useAppState();
  if (isShortVersion) return (
    <div className={`relative ${getStatusColor(moldOrder.status, moldOrder.type, { variant: 'strong' })} rounded-full w-4 h-4 border-2 border-white`}></div>
  )
  return (
    <span
      className={`${getStatusColor(moldOrder.status, moldOrder.type)} px-3 py-1 rounded-full text-sm font-medium w-fit`}
      data-cy="mold-order-status"
    >
      {getStatusText(moldOrder.status, moldOrder.type)}
    </span>
  );
};

export default MoldOrderStatus;
